<!-- 🆕 Stats de cuotas. Solo se renderiza si hay cuotas. -->
<ng-container *ngIf="total > 0">

  <!-- ============================================================ -->
  <!-- Variante CARD: bloque destacado con título + grilla de stats -->
  <!-- ============================================================ -->
  <div *ngIf="variant === 'card'"
       class="rounded-xl border border-gray-200 bg-white p-4">
    <div class="flex items-center justify-between mb-3">
      <h4 class="text-sm font-semibold text-gray-900">{{ title }}</h4>
      <span class="text-xs font-medium text-gray-500">Total: {{ total }}</span>
    </div>

    <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-2">

      <!-- Pagadas -->
      <div class="rounded-lg border border-emerald-200 bg-emerald-50 p-3 flex items-center gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-700">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"/>
          </svg>
        </div>
        <div class="min-w-0">
          <p class="text-[10px] font-semibold uppercase tracking-wide text-emerald-700 truncate">Pagadas</p>
          <p class="text-xl font-bold text-emerald-900 leading-tight">{{ paidCount }}</p>
        </div>
      </div>

      <!-- Parcialmente pagadas -->
      <div class="rounded-lg border border-amber-200 bg-amber-50 p-3 flex items-center gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-amber-100 text-amber-700">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
          </svg>
        </div>
        <div class="min-w-0">
          <p class="text-[10px] font-semibold uppercase tracking-wide text-amber-700 truncate">Parciales</p>
          <p class="text-xl font-bold text-amber-900 leading-tight">{{ partialCount }}</p>
        </div>
      </div>

      <!-- Pendientes -->
      <div class="rounded-lg border border-gray-200 bg-gray-50 p-3 flex items-center gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gray-200 text-gray-600">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
          </svg>
        </div>
        <div class="min-w-0">
          <p class="text-[10px] font-semibold uppercase tracking-wide text-gray-600 truncate">Pendientes</p>
          <p class="text-xl font-bold text-gray-900 leading-tight">{{ pendingCount }}</p>
        </div>
      </div>

      <!-- Link generado -->
      <div class="rounded-lg border border-indigo-200 bg-indigo-50 p-3 flex items-center gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-indigo-100 text-indigo-700">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"/>
          </svg>
        </div>
        <div class="min-w-0">
          <p class="text-[10px] font-semibold uppercase tracking-wide text-indigo-700 truncate">Con link</p>
          <p class="text-xl font-bold text-indigo-900 leading-tight">{{ linkGeneratedCount }}</p>
        </div>
      </div>

      <!-- Vencidas (overdue) -->
      <div class="rounded-lg border border-rose-200 bg-rose-50 p-3 flex items-center gap-3">
        <div class="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-rose-100 text-rose-700">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01M5 19h14a2 2 0 001.84-2.75L13.74 4a2 2 0 00-3.48 0L3.16 16.25A2 2 0 005 19z"/>
          </svg>
        </div>
        <div class="min-w-0">
          <p class="text-[10px] font-semibold uppercase tracking-wide text-rose-700 truncate">Vencidas</p>
          <p class="text-xl font-bold text-rose-900 leading-tight">{{ overdueCount }}</p>
        </div>
      </div>
    </div>

    <!-- Castigadas: solo se muestra si hay alguna y showPunished=true -->
    <div *ngIf="showPunished && punishedCount > 0"
         class="mt-3 flex items-center justify-between rounded-lg border border-red-200 bg-red-50 px-3 py-2">
      <div class="flex items-center gap-2">
        <svg class="h-4 w-4 text-red-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728L5.636 5.636m12.728 12.728L18.364 5.636M5.636 18.364l12.728-12.728"/>
        </svg>
        <span class="text-xs font-semibold text-red-800">Cartera castigada</span>
      </div>
      <span class="text-sm font-bold text-red-700">{{ punishedCount }}</span>
    </div>
  </div>

  <!-- ============================================================ -->
  <!-- Variante INLINE: pills delgadas para usos compactos          -->
  <!-- ============================================================ -->
  <div *ngIf="variant === 'inline'" class="flex flex-wrap items-center gap-2">
    <span class="inline-flex items-center gap-1.5 rounded-full bg-emerald-50 border border-emerald-200 px-2.5 py-0.5 text-xs font-semibold text-emerald-700">
      <span class="h-1.5 w-1.5 rounded-full bg-emerald-500"></span>
      Pagadas {{ paidCount }}
    </span>
    <span *ngIf="partialCount > 0" class="inline-flex items-center gap-1.5 rounded-full bg-amber-50 border border-amber-200 px-2.5 py-0.5 text-xs font-semibold text-amber-700">
      <span class="h-1.5 w-1.5 rounded-full bg-amber-500"></span>
      Parciales {{ partialCount }}
    </span>
    <span class="inline-flex items-center gap-1.5 rounded-full bg-gray-100 border border-gray-200 px-2.5 py-0.5 text-xs font-semibold text-gray-700">
      <span class="h-1.5 w-1.5 rounded-full bg-gray-400"></span>
      Pendientes {{ pendingCount }}
    </span>
    <span *ngIf="linkGeneratedCount > 0" class="inline-flex items-center gap-1.5 rounded-full bg-indigo-50 border border-indigo-200 px-2.5 py-0.5 text-xs font-semibold text-indigo-700">
      <span class="h-1.5 w-1.5 rounded-full bg-indigo-500"></span>
      Con link {{ linkGeneratedCount }}
    </span>
    <span *ngIf="overdueCount > 0" class="inline-flex items-center gap-1.5 rounded-full bg-rose-50 border border-rose-200 px-2.5 py-0.5 text-xs font-semibold text-rose-700">
      <span class="h-1.5 w-1.5 rounded-full bg-rose-500"></span>
      Vencidas {{ overdueCount }}
    </span>
    <span *ngIf="showPunished && punishedCount > 0" class="inline-flex items-center gap-1.5 rounded-full bg-red-50 border border-red-200 px-2.5 py-0.5 text-xs font-semibold text-red-700">
      <span class="h-1.5 w-1.5 rounded-full bg-red-600"></span>
      Castigadas {{ punishedCount }}
    </span>
  </div>

</ng-container>
